import type { ReactNode } from "react";
export const Chargement = () => <p className="text-sm text-muted-foreground">Chargement…</p>;
export const Erreur = ({ message }: { message: string }) => <p className="text-sm text-red-700">{message}</p>;
export const Titre = ({ children, sous }: { children: ReactNode; sous?: ReactNode }) => (
  <div className="mb-4">
    <h1 className="text-2xl font-bold">{children}</h1>
    {sous && <p className="text-sm text-muted-foreground">{sous}</p>}
  </div>
);
